import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, onBeforeMount, onUnmounted } from "vue";
import SearchPage from "@/components/v2/search-page/SearchPage.vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'Disbursements',
  setup(__props) {

const loading = ref<boolean>(false);
const searchPageStore = useSearchPageStore();

/////////////////////////////////////////////////////////////////
// vue onMounted - executes when the page is finished mounting //
/////////////////////////////////////////////////////////////////
onBeforeMount(async () => {
  await searchPageStore.getFilters("disbursement");
  await searchPageStore.getDisbursements();
});

onMounted(async () => {
  loading.value = false;
});

onUnmounted(() => {
  searchPageStore.$reset();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SearchPage, {
    pageName: "Disbursements",
    searchBoxPlaceholderText: `Search by CLUID, First name, Last name, App ID`
  }))
}
}

})